export enum ResponseState {
  Undefined,
  Accepted,
  Declined
}
